module.exports = __webpack_public_path__ + "img/grey_052.f1b2b023.png";